import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/es';
import vueMoment from 'vue-moment';

Vue.use(vueMoment, { moment });
